import React, { useState, useContext, useEffect } from "react";
import { Text, TextInput, View, StyleSheet, TouchableOpacity, Modal, useWindowDimensions } from "react-native";

import { PaymentMethodsContext } from "../context/PaymentMethodsContext";
import { CartContext } from "../context/CartContext";
import { GlobalContext } from "../context/GlobalContext";

import CartElement from "../components/CartElement";
import PaymentMethodsElement from "../components/PaymentMethodsElement";
import WooService from "../services/WooService";

import Config from "../config/Config";
import { ScrollView } from "react-native-gesture-handler";

const config = new Config();

const PAYMENT_CONTROL = true;
const PARTIAL_PAYMENT = false;
const DEFAULT_PAYMENT_ID = PAYMENT_CONTROL ? "0" : config.OPEN_PAYMENT;
const DEFAULT_PAYMENT_NAME = PAYMENT_CONTROL ? "" : "Consumo no local";
const PAYMENT_SUCCESS = 0;

const CART_SIZE_PORTRAIT = 320;
const WIDTH_TRESHOLD = 640;

const OrderDetailsScreen = ({ route, navigation }) => {
  const { width, height } = useWindowDimensions();
  const { cart, loadOrderIntoCart, getCartTotal, setKeepCart } = useContext(CartContext);
  const { paymentMethods } = useContext(PaymentMethodsContext);
  const [order, setOrder] = useState();
  const [currentPayment, setCurrentPayment] = useState({id: DEFAULT_PAYMENT_ID, name: DEFAULT_PAYMENT_NAME});
  const [paymentValue, setPaymentValue] = useState(null);
  const [paymentVisible, setPaymentVisible] = useState(false);
  const [step, setStep] = useState('show');
  const [modalVisible, setModalVisible] = useState(false);
  const [waitModalVisible, setWaitModalVisible] = useState(false);
  const [modalConfig, setModalConfig] = useState({modalText: '', modalButtonText:'', modalAction: null});
  const [discountModalVisible, setDiscountModalVisible] = useState(false);
  const [absoluteDiscount, setAbsoluteDiscount] = useState();
  const [percentDiscount, setPercentDiscount] = useState();
  const { elginPayService } = useContext(GlobalContext);

  const statusList = [['pending', 'on-hold', 'processing', 'completed', 'cancelled', 'other'], ['Pendente', 'Aguardando', 'Processando', 'Concluído', 'Cancelado', 'Outro']];

  const { selectedOrder, navigationAction } = route.params;

  const syncCall = async (asyncFunction, ...args) => {
    setWaitModalVisible(true);
    await asyncFunction(...args);
    setWaitModalVisible(false);
  }

  useEffect(() => {
    if (navigationAction === 'OPEN_ORDER') {
      syncCall(loadOrderIntoCart, selectedOrder);
      setKeepCart(false);
    }
    setOrder(selectedOrder);
    /*
    const blurSubscription = navigation.addListener('blur', () => {
      console.log("currentAction: ", currentAction);
      if (currentAction !== 'add') {
        clearCart();
      }
      return blurSubscription;
    });
    */
  }, [order]);

  const index = statusList[0].indexOf(selectedOrder.status);
  const statusDescription = statusList[1][index];

  const getStatusBackground = (status) => {
    switch(status) {
      case 'pending':
      case 'on-hold':
        return {backgroundColor: config.ON_HOLD_COLOR};
      case 'processing':
        return {backgroundColor: config.PROCESSING_COLOR};
      case 'completed':
        return {backgroundColor: config.COMPLETED_COLOR};
      case 'cancelled':
        return {backgroundColor: config.CANCELLED_COLOR};
      default:
        return {backgroundColor: config.ON_HOLD_COLOR};
    }
  }

  const getPaymentMethod = () => {
    if (selectedOrder.status == 'processing' || selectedOrder.status == 'completed') {
      return '(' + selectedOrder.paymentMethodName + ')';
    }
    return '';
  }

  const showButton = (button, orderStatus, origin) => {
    switch(button) {
      case 'add_items':
      case 'discount':
      case 'save':
        return (origin === 'rest-api') && (orderStatus === 'on-hold');
        break;
      case 'payment':
        return (['on-hold', 'pending', 'processing'].includes(orderStatus)) && (['rest-api', 'checkout'].includes(origin));
        break;
      case 'cancel':
        return ['on-hold', 'pending', 'processing'].includes(orderStatus);
        break;
      case 'print':
        return (orderStatus !== 'cancelled');
        break;
      case 'reopen':
        return ['cancelled', 'completed'].includes(orderStatus);
        break;
      case 'accept':
        return (origin === 'ifood') && (['on-hold', 'pending'].includes(orderStatus));
        break;
      case 'dispatch':
        return (origin === 'ifood') && (orderStatus === 'processing');
        break;
      default:
        return false;
    }
  }

  const updateOrder = (response) => {
    const data = JSON.parse(response.config.data);

    if (data.action === 'bill') {
      return;
    }

    if (response.status === 200) {
      let newOrder = order;
      newOrder.status = data.status;
      if (['update', 'close'].includes(data.action)) {
        newOrder.items = data.line_items.map(item => {
          return {
            id: item.variation_id && item.variation_id > 0 ? item.variation_id : item.product_id,
            sku: item.sku,
            name: item.name,
            price: item.price,
            quantity: item.quantity,
          }
        });
        newOrder.fees = data.fee_lines;
        newOrder.shippings = data.shipping_lines;
        if (data.action === 'close') {
          newOrder.paymentMethodId = data.payment_method;
          newOrder.paymentMethodName = data.payment_method_title;
        }
      }
      newOrder.total = getCartTotal();
      setOrder(newOrder);
    } else {
      alert("Ocorreu algum erro ao atualizar o pedido.");
    }
  }  

  const updateOrderDiscount = (response) => {
    const data = JSON.parse(response.config.data);

    if (response.status === 200) {
      let newOrder = order;
      let feeFound = false;
      newOrder.fees = order.fees.map(fee => {
        if (fee.name == "Desconto") {
          fee.price = -data.discount;
          fee.quantity = 1;
          fee.total = -data.discount;
          feeFound = true;
        }
        return fee;
      });
      if (!feeFound) {
        newOrder.fees.push({
          name: "Desconto",
          price: -data.discount,
          quantity: 1,
          total: -data.discount
        });
      }
      newOrder.total = getCartTotal();
      setOrder(newOrder);
      syncCall(loadOrderIntoCart, newOrder);
    } else {
      alert("Ocorreu algum erro ao atualizar o pedido.");
    }
  }  

  const closePayment = async () => {
    if (currentPayment && currentPayment.id !== config.OPEN_PAYMENT) {
      // All payment methods other than Elgin Pay assume the payment was done
      let status = PAYMENT_SUCCESS;
      if (config.BUILD_PRODUCT === config.CONTROL_CENTER_ELGINPAY && [config.CREDIT_CARD_ELGIN, config.DEBIT_CARD_ELGIN].includes(currentPayment.id)) {
        status = await elginPayService.doElginPay(currentPayment.id === config.CREDIT_CARD_ELGIN ? 'credit' : 'debit', getCartTotal());
      }
      const isPaid = (status === PAYMENT_SUCCESS && currentPayment.id !== config.PEN_PAYMENT);
      setWaitModalVisible(true);
      const wooService = new WooService();
      const response = await wooService.closeOrder(order, cart, currentPayment, isPaid);
      updateOrder(response);
      setWaitModalVisible(false);
      setKeepCart(false);
      navigation.navigate('Orders', { order: order });
    }
  }

  const addItems = () => {
    setKeepCart(true);
    navigation.navigate("Categories", {navigationAction: 'EDIT_ORDER', order: order});
  }

  const acceptIfoodOrder = async () => {
    const wooService = new WooService();
    setWaitModalVisible(true);
    const response = await wooService.acceptIfoodOrder(order.id);
    updateOrder(response);
    setWaitModalVisible(false);
    setKeepCart(false);
    navigation.navigate('Orders', { order: order });
  }

  const dispatchIfoodOrder = async () => {
    const wooService = new WooService();
    setWaitModalVisible(true);
    const response = await wooService.dispatchIfoodOrder(order.id);
    setWaitModalVisible(false);
    setKeepCart(false);
    navigation.navigate('Orders', { order: order });
  }

  const updatePercentDiscount = (value) => {
    if (value) {
      const cartTotal = getCartTotal();
      if (value > 100) {
        value = 100;
      }
      value = value.replace(',', '.');
      const absoluteValue = parseFloat(value) * cartTotal / 100;
      setPercentDiscount(value);
      setAbsoluteDiscount(absoluteValue.toFixed(2));
    } else {
      setPercentDiscount(0);
      setAbsoluteDiscount(0);
    }
  }

  const updateAbsoluteDiscount = (value) => {
    if (value) {
      const cartTotal = getCartTotal();
      if (value > cartTotal) {
        value = cartTotal;
      }
      value = value.replace(',', '.');
      const percentValue = parseFloat(value) / cartTotal * 100;
      setAbsoluteDiscount(value);
      setPercentDiscount(percentValue.toFixed(2));
    } else {
      setPercentDiscount(0);
      setAbsoluteDiscount(0);
    }
  }

  const getDiscount = async () => {
    const wooService = new WooService();
    const discount = absoluteDiscount;
    if (absoluteDiscount >= 0) {
      // setDiscountModalVisible(true);
      const response = await wooService.saveDiscount(order, discount);
      updateOrderDiscount(response);
      setDiscountModalVisible(false);
    }
    // setKeepCart(false);
    // navigation.navigate('Orders', { order: order });
  }

  const saveOrder = async () => {
    const wooService = new WooService();
    setWaitModalVisible(true);
    const response = await wooService.updateOrder(order, cart);
    updateOrder(response);
    setWaitModalVisible(false);
    setKeepCart(false);
    navigation.navigate('Orders', { order: order });
  }

  const reopenOrder = async () => {
    const wooService = new WooService();
    setWaitModalVisible(true);
    const response = await wooService.updateOrderStatus(order, 'on-hold');
    updateOrder(response);
    setWaitModalVisible(false);
    setKeepCart(false);
    navigation.navigate('Orders', { order: order });
  }

  const cancelOrder = async () => {
    const wooService = new WooService();
    setWaitModalVisible(true);
    const response = order.origin === 'ifood' ?
      await wooService.cancelIfoodOrder(order.id) :
      await wooService.updateOrderStatus(order, 'cancelled');
    updateOrder(response);
    setWaitModalVisible(false);
    setKeepCart(false);
    navigation.navigate('Orders', { order: order, response: response });
  }

  const printOrderBill = async () => {
    const wooService = new WooService();
    const response = await wooService.printOrderBill(order.id);
    setKeepCart(false);
    navigation.navigate('Orders', { order: order, response: response });
  }

  const portrait = (width < WIDTH_TRESHOLD);
  const cartHeight = portrait ? CART_SIZE_PORTRAIT : height - 220;
  const buttonSize = portrait ? (width-10)/2 : (width-65)/6;
  
  return (
    <View style={styles.contentContainer}>
        <Modal
          animationType="fade"
          transparent={true}
          visible={modalVisible}
          // If using react-native Modal implementaion, change "onDismiss" to "onRequestClose"
          onDismiss={() => {
            // alert("Pedido cancelado!");
          }}>
          <View style={styles.modalView}>
            <Text style={styles.modalText}>{modalConfig.modalText}</Text>
            <TouchableOpacity style={[styles.buttons, styles.modalButtons]} onPress={() => {
                setModalVisible(false);
                modalConfig.modalAction();
              }}>
              <Text style={styles.buttonText}>{modalConfig.modalButtonText}</Text>
            </TouchableOpacity>
            <TouchableOpacity style={[styles.buttons, styles.modalButtons]} onPress={() => setModalVisible(false)}>
            <Text style={styles.buttonText}>Voltar</Text>
          </TouchableOpacity>
        </View>        
      </Modal>
      <Modal
        transparent={true}
        visible={waitModalVisible}
        // If using react-native Modal implementaion, change "onDismiss" to "onRequestClose"
        onDismiss={() => {
            // alert("Pedido atualizado!");
        }}>
        <View style={styles.modalView}>
            <Text style={styles.modalText}>Aguarde. Atualizando pedido...</Text>
        </View>        
      </Modal>
      <Modal
        animationType="fade"
        transparent={true}
        visible={discountModalVisible}
        onDismiss={() => {
            // alert("Pedido atualizado!");
        }}>
        <View style={styles.modalView}>
          <Text style={styles.inputLabel}>Valor do Desconto</Text>
          <TextInput
            style={styles.input}
            onChangeText={updateAbsoluteDiscount}
            value={absoluteDiscount}
            placeholder='Desconto (em R$)'
            keyboardType='decimal-pad'
          />
          <Text style={styles.inputLabel}>Desconto (%)</Text>
          <TextInput
            style={[styles.input, {marginBottom: 30}]}
            onChangeText={updatePercentDiscount}
            value={percentDiscount}
            placeholder='Desconto (em %)'
            keyboardType='decimal-pad'
          />
          <TouchableOpacity style={[styles.buttons, {marginBottom: 15}]} onPress={getDiscount}>
            <Text style={styles.buttonText}>Confirmar</Text>
          </TouchableOpacity>
          <TouchableOpacity style={styles.buttons} onPress={() => setDiscountModalVisible(false)}>
            <Text style={styles.buttonText}>Voltar</Text>
          </TouchableOpacity>
        </View>        
      </Modal>
      <ScrollView horizontal>
        <Text style={styles.orderTitle}>{selectedOrder.number} - {selectedOrder.firstName} {selectedOrder.lastName}</Text>
      </ScrollView>
      <View style={[styles.statusBox, getStatusBackground(selectedOrder.status)]}>
        <Text style={{fontSize: 18}}>Situação: {statusDescription} {getPaymentMethod()}</Text>
      </View>
      <View style={styles.orderView}>
        <View style={{height: cartHeight}}>
          <CartElement 
            action={['on-hold', 'pending'].includes(selectedOrder.status) ? 'edit' : 'show'} 
            maxHeight={cartHeight} 
            origin={selectedOrder.origin} 
            customerNotes={selectedOrder.customerNotes}
            address={selectedOrder.address}
          />
        </View>
        {step === 'show' &&
          <View style={portrait ? styles.footerPortrait : styles.footerLandscape}>
            {showButton('accept', selectedOrder.status, selectedOrder.origin) &&
              <TouchableOpacity style={[styles.buttons, {width: buttonSize}]} onPress={acceptIfoodOrder}>
                <Text style={styles.buttonText}>Aceitar pedido</Text>
              </TouchableOpacity>
            }              
            {showButton('dispatch', selectedOrder.status, selectedOrder.origin) &&
              <TouchableOpacity style={[styles.buttons, {width: buttonSize}]} onPress={dispatchIfoodOrder}>
                <Text style={styles.buttonText}>Despachar pedido</Text>
              </TouchableOpacity>
            }   
            {showButton('add_items', selectedOrder.status, selectedOrder.origin) &&
              <TouchableOpacity style={[styles.buttons, {width: buttonSize}]} onPress={addItems}>
                <Text style={styles.buttonText}>Adicionar itens</Text>
              </TouchableOpacity>
            }
            {showButton('discount', selectedOrder.status, selectedOrder.origin) &&
              <TouchableOpacity style={[styles.buttons, {width: buttonSize}]} onPress={() => setDiscountModalVisible(true)}>
                <Text style={styles.buttonText}>Desconto</Text>
              </TouchableOpacity>
            }
            {showButton('save', selectedOrder.status, selectedOrder.origin) &&
              <TouchableOpacity style={[styles.buttons, {width: buttonSize}]} onPress={saveOrder}>
                <Text style={styles.buttonText}>Salvar</Text>
              </TouchableOpacity>
            }
            {showButton('payment', selectedOrder.status, selectedOrder.origin) &&
              <TouchableOpacity style={[styles.buttons, {width: buttonSize}]} onPress={() => {
                setPaymentVisible(true);
                if (PARTIAL_PAYMENT) {
                  setPaymentValue(getCartTotal());
                }
                setStep('confirm');
              }}>
                <Text style={styles.buttonText}>Pagamento</Text>
              </TouchableOpacity>
            }
            {showButton('print', selectedOrder.status, selectedOrder.origin) &&
              <TouchableOpacity style={[styles.buttons, {width: buttonSize}]} onPress={printOrderBill}>
                <Text style={styles.buttonText}>Imprimir</Text>
              </TouchableOpacity>              
            }
            {showButton('reopen', selectedOrder.status, selectedOrder.origin) &&
              <TouchableOpacity style={[styles.buttons, {width: buttonSize}]} onPress={() => { 
                setModalConfig({
                  modalText: "Deseja reamente reabrir o pedido?",
                  modalButtonText: "Reabrir pedido",
                  modalAction: reopenOrder
                });
                setModalVisible(true); 
              }}>
                <Text style={styles.buttonText}>Reabrir</Text>
              </TouchableOpacity>            
            }           
            {showButton('cancel', selectedOrder.status, selectedOrder.origin) &&
              <TouchableOpacity style={[styles.buttons, {width: buttonSize}]} onPress={() => {
                setModalConfig({
                  modalText: "Deseja realmente cancelar o pedido?",
                  modalButtonText: "Cancelar pedido",
                  modalAction: cancelOrder
                });
                setModalVisible(true); 
              }}>
                <Text style={styles.buttonText}>Cancelar</Text>
              </TouchableOpacity>                
            }
          </View>
        }
        {step === 'confirm' &&
          <View style={portrait ? styles.footerPortrait : styles.footerLandscape}>
            <TouchableOpacity style={styles.buttons} onPress={() => {
              setStep('show');
              setPaymentVisible(false);
            }}>
              <Text style={styles.buttonText}>Voltar</Text>
            </TouchableOpacity>
            {PAYMENT_CONTROL && paymentVisible &&
              <PaymentMethodsElement
                paymentMethods={paymentMethods}
                currentPayment={currentPayment}
                setCurrentPayment={setCurrentPayment}>
              </PaymentMethodsElement>
            }
            {PARTIAL_PAYMENT &&
              <View style={{flexDirection: 'row'}}>
                <Text style={styles.inputLabel}>R$</Text>
                <TextInput
                  style={styles.input}
                  onChangeText={setPaymentValue}
                  value={paymentValue}
                  keyboardType="numeric"
                  placeholder="Valor pago"/>
              </View>
            }
            <TouchableOpacity style={styles.buttons} onPress={() => {
              if (currentPayment.id !== DEFAULT_PAYMENT_ID) {
                closePayment();
              } else {
                alert('Por favor, selecione a forma de pagamento');
              }
            }}>
              <Text style={styles.buttonText}>Confirmar Pagamento</Text>
            </TouchableOpacity>
          </View>
        }
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  contentContainer: {
    paddingBottom: 20,
    margin: 5
  },
  orderTitle: {
    fontSize: 24,
    marginLeft: 5,
    marginVertical: 5
  },
  statusBox: {
    marginTop: 5,
    marginHorizontal: 0,
    padding: 12,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10
  },
  orderView: {
    flexDirection: 'column',
    justifyContent: 'flex-start'
  },
  listStyle: {
    marginHorizontal: 5,
    marginVertical: 1
  },
  itemStyle: {
    fontSize: 16,
    fontWeight: 'bold'
  },
  footerLandscape: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignContent: 'center',
    marginTop: 5
  },
  footerPortrait: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignContent: 'center',
    marginTop: 5
  },
  buttons: {
    backgroundColor: '#965E11',
    width: 175,
    height: 40,
    paddingVertical: 10,
    borderRadius: 10,
    marginHorizontal: 5,
    marginBottom: 4,
    alignSelf: 'center'
  },
  buttonText: {
    fontSize: 15,
    fontWeight: 'bold',
    alignSelf: 'center',
    color: 'white'
  },
  total: {
    flexDirection: 'row',
    alignSelf: 'flex-end',
    marginRight: 10
  },
  totalHeader: {
    backgroundColor: 'orange',
    justifyContent: 'center',
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10
  },
  totalTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    paddingHorizontal: 25,
    paddingVertical: 8
  },
  totalValue: {
    borderColor: 'orange',
    borderWidth: 3,
    justifyContent: 'center',
    paddingHorizontal: 10,
    borderTopRightRadius: 10,
    borderBottomRightRadius: 10
  },
  totalInfo: {
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'center',
    width: 80
  },
  inputLabel: {
    fontSize: 18,
    fontWeight: 'bold',
    marginTop: 23,
    marginBottom: 10,
    marginHorizontal: 10,
    paddingHorizontal: 35
  },
  input: {
    fontSize: 16,
    height: 40,
    borderWidth: 1,
    padding: 8,
    borderRadius: 10
  },
  modalView: {
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    marginTop: 40,
    backgroundColor: "white",
    borderRadius: 20,
    paddingVertical: 30,
    paddingHorizontal: 30,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5
  },
  modalText: {
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: 20
  },
  modalButtons: {
    marginVertical: 10
  }
});

export default OrderDetailsScreen;